(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["variant-main-picker"] && !Shopify.designMode) return;
  try {
    // Sync variant pickers - connects button-style and dropdown-style pickers
  document.addEventListener('DOMContentLoaded', function() {
    const variantPickers = document.querySelectorAll('variant-picker');
    
    if (variantPickers.length < 2) return;
    
    variantPickers.forEach(picker => {
      // Listen for radio button changes
      picker.querySelectorAll('input[type="radio"]').forEach(radio => {
        radio.addEventListener('change', function() {
          syncVariantSelection(this, variantPickers);
        });
      });
      
      // Listen for select dropdown changes
      picker.querySelectorAll('select.variant-option__select').forEach(select => {
        select.addEventListener('change', function() {
          syncVariantSelection(this, variantPickers);
        });
      });
    });
    
    function syncVariantSelection(changedInput, allPickers) {
      const optionValueId = changedInput.dataset.optionValueId || 
                           changedInput.selectedOptions?.[0]?.dataset.optionValueId;
      const value = changedInput.value;
      
      if (!optionValueId && !value) return;
      
      allPickers.forEach(picker => {
        if (picker.contains(changedInput)) return;
        
        // Sync radio buttons
        const matchingRadio = picker.querySelector(`input[type="radio"][data-option-value-id="${optionValueId}"]`) ||
                             picker.querySelector(`input[type="radio"][value="${value}"]`);
        if (matchingRadio && !matchingRadio.checked) {
          matchingRadio.checked = true;
          matchingRadio.dispatchEvent(new Event('change', { bubbles: true }));
        }
        
        // Sync dropdowns
        const matchingSelect = picker.querySelector('select.variant-option__select');
        if (matchingSelect) {
          const matchingOption = matchingSelect.querySelector(`option[data-option-value-id="${optionValueId}"]`) ||
                                matchingSelect.querySelector(`option[value="${value}"]`);
          if (matchingOption && !matchingOption.selected) {
            matchingSelect.value = matchingOption.value;
            matchingSelect.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      });
    }
  });
  } catch(e) { console.error(e); }
})();

})();
